import { useMemo } from 'react'
import { useDataFormat } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let send_next_appointment_reminder = useDataFormat({
    context: 'global',
    path: 'feature_flags.is_automation_hub_comms_enabled',
    viewPath: props.viewPath,
    format: value => !value,
  })
  return useMemo(() => {
    if (!data) return data
    return { ...data, send_next_appointment_reminder }
  }, [])
}
